import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./components/App";
import { UserContextProvider } from "./contexts/UserContext";

const root = createRoot(document.querySelector("#app")!);
root.render(
  <UserContextProvider>
    <App />
  </UserContextProvider>
);
